<template>
  <div
    class="flex justify-center mt-auto mb-18"
  >
    <action-button
      v-if="(firstLogin ||emailWasJustVerified) && isCurrent"
      border-color="border-transparent"
      text-color="text-white"
      bg-color="bg-indigo-600"
      bg-color-square="bg-indigo-600"
      icon-color="text-white"
      libelle="Continuer avec l'offre gratuite"
      icon="arrow-right_1"
      :responsive="false"
      type-shadow="shadow-indigo"
      @clickAction="continueWithFreeSubscription()"
    />

    <div
      v-else-if="isCurrent"
      class="relative text-sm font-normal text-gray-600 border-b border-gray-600 w-full flex items-center bottom-5"
    >
      <span class="absolute w-full text-center">
        <span class="w-max-content w-max bg-indigo-200 px-2">Votre offre actuelle</span>
      </span>
    </div>



    <div v-else>
      <action-button
        border-color="border-transparent"
        text-color="text-white"
        bg-color="bg-indigo-600"
        bg-color-square="bg-indigo-600"
        icon-color="text-white"
        libelle="Contactez-nous"
        icon="email"
        :responsive="false"
        type-shadow="shadow-indigo"
        @clickAction="
          $store.commit('account/SET_SHOW_CONTACT_OFFER_POPUP', name)
        "
      />
    </div>
  </div>
</template>
<script>
import ActionButton from '../../../components/ActionButton.vue';
import {mapGetters, mapMutations} from 'vuex';

export default {
  props: {
    name: {
      type: String,
      required: true
    },
    isCurrent: {
      type: Boolean,
      required: true
    }
  },
  components: {
    ActionButton
  },

  methods: {
    ...mapMutations({
      SET_ISFIRSTLOGIN: 'auth/SET_ISFIRSTLOGIN',
    }),

    continueWithFreeSubscription() {
      this.SET_ISFIRSTLOGIN(false);

      this.$router.replace({name: 'Dashboard'});
    }
  },

  computed: {
    ...mapGetters({
      'firstLogin': 'auth/isFirstLogin'
    }),

    emailWasJustVerified() {
      return this.$route.path.split('/').reverse()[0] === 'verified';
    }
  }
};
</script>